export default __webpack_public_path__ + "static/media/avatar_elephant1.e40dc625.mp3";